import {
    GETENTITYTYPELIST_SUCCESS,
    GETENTITYTYPELIST_FAILED,
    RESET_GETENTITYTYPELIST,
    LOADING_GETENTITYTYPELIST,
    NETWORK_ERROR_GETENTITYTYPELIST,
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetGetEntityTypeList = () => {
    return { type: RESET_GETENTITYTYPELIST };
};

const getEntityTypeList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETENTITYTYPELIST });
    await adminServices
        .post("getEntityTypeList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(getEntityTypeListsuccess(res.data));
                    break;
                default:
                    dispatch(getEntityTypeListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({ type: NETWORK_ERROR_GETENTITYTYPELIST, payload: err });
        });
};
function getEntityTypeListsuccess(data) {
    return {
        type: GETENTITYTYPELIST_SUCCESS,
        payload: data,
    };
}
function getEntityTypeListFailed(data) {
    return {
        type: GETENTITYTYPELIST_FAILED,
        payload: data,
    };
}

export { resetGetEntityTypeList, getEntityTypeList };
